import { useGetValuationProfileQuery } from "../../../redux";

const usePortfolioProfile = () => {
    const data = useGetValuationProfileQuery();
    return {
        ...data
    };
};

export default usePortfolioProfile;